import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultWMS1022_R01Filter, WMS1022_R01Filter, useWMS1022_R01Store } from 'src/containers/mes/WMS/WMS1022_R01/Store_WMS1022_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteWMS1022_R01, downloadExcel_WMS1022_R01, getWMS1022_R01AllCount, getWMS1022_R01DetailList, getWMS1022_R01List, getWMS1022_R01LotList, getWMS1022_R01One, getWMS1022_R01TransportHeader, getWMS1022_R01WmsTransport, patchWMS1022_R01, postWMS1022_R01, createWMS1022_R01LotNo } from "./Api_WMS1022_R01";
import { defaultWMS1022_R01DetailDto, defaultWMS1022_R01HeaderDto, defaultWMS1022_R01LotDto, WMS1022_R01DetailDto, WMS1022_R01Dto, WMS1022_R01HeaderDto, WMS1022_R01LotDto } from './Dto_WMS1022_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler, InsertRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { formatDate, validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	WMS1022_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { LabelPrintData } from 'src/apis/labelApi';
import { WMS1022_R01_extractUnprintedLabelData } from './labelDataBuilder_WMS1022_R01';
import { useQzPrint } from 'src/hooks/useQzPrint';
import { getDefaultLabelPrintAuto } from 'src/utils/label/labelPrintAutoProgramUtil';


interface Props {
	gridRef: React.RefObject<AgGridReact<WMS1022_R01HeaderDto> | null>;
	lotGridRef: React.RefObject<AgGridReact<WMS1022_R01LotDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<WMS1022_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}

export const Content_WMS1022_R01 = (props: Props) => {
	const { printBulkLabel } = useQzPrint();

	const {
		gridRef, lotGridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	
	const {
		WMS1022_R01Filter, setWMS1022_R01Filter,
		WMS1022_R01PastFilter, setWMS1022_R01PastFilter,
		WMS1022_R01List, setWMS1022_R01List,
		editWMS1022_R01, setEditWMS1022_R01,
		selectedWMS1022_R01, setSelectedWMS1022_R01, 
		deletedWMS1022_R01DetailList, setDeletedWMS1022_R01DetailList, addDeletedWMS1022_R01DetailList, removeDeletedWMS1022_R01DetailList, 
		selectedWMS1022_R01DetailList, setSelectedWMS1022_R01DetailList, addSelectedWMS1022_R01DetailList, removeSelectedWMS1022_R01DetailList,
		WMS1022_R01DetailList, setWMS1022_R01DetailList, insertWMS1022_R01DetailList,
		originalWMS1022_R01DetailList, setOriginalWMS1022_R01DetailList,
		WMS1022_R01LotMap, setWMS1022_R01LotMap,
		selectedItemCdForLot, setSelectedItemCdForLot,
		setWMS1022_R01LotList, insertWMS1022_R01LotList, resetWMS1022_R01LotList,
		selectedWMS1022_R01LotList, setSelectedWMS1022_R01LotList, addSelectedWMS1022_R01LotList, removeSelectedWMS1022_R01LotList, initSelectedWMS1022_R01LotList,
		deletedWMS1022_R01LotList, setDeletedWMS1022_R01LotList, addDeletedWMS1022_R01LotList, removeDeletedWMS1022_R01LotList,
		originalWMS1022_R01LotList, setOriginalWMS1022_R01LotList,
		allCount, setAllCount,
		transportComplete, setTransportComplete,
		detailFetchTrigger, setDetailFetchTrigger,
		lotFetchTrigger, setLotFetchTrigger,
		initData, 
		setAutoLotQtyIfEmpty,
		warehouseCdListToUseList,
		setScrollTop, setDetailScrollTop, setLotScrollTop,
	} = useWMS1022_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { inoutClassList, inoutTypeList, inoutMethodList, wmsCdList, wmsInTypeCdList, yesNoList, compCdList, customCdList, employeeCdList, warehouseCdList, programList } = useCommonCodeStore();

	const defaultLabelPrintAuto = useMemo(
		() => getDefaultLabelPrintAuto(programList),
		[programList]
	);

	useFetchActionbarAuth("WMS1022_R01");

	const [clickable, setClickable] = useState(true);

	const prevWmsOrderNoRef = useRef<string | undefined>(undefined);
	
	const handleExcelClick = useCallback(async () => {
		if (!selectedWMS1022_R01) {
			showWarning("선택된 입고정보내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_WMS1022_R01('', selectedWMS1022_R01.wmsOrderNo, selectedWMS1022_R01.warehouseCd, WMS1022_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '입고정보 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedWMS1022_R01])

	const getParams = (filter: WMS1022_R01Filter) => {
		const params: Partial<WMS1022_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			wmsOrderNo: filter.wmsOrderNo || undefined,
			customCd: filter.customCd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getWMS1022_R01AllCount(getParams(WMS1022_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [WMS1022_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		prevWmsOrderNoRef.current = undefined;
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);
		setLotScrollTop(null);
	
		const responseData = (await getWMS1022_R01List(
			'',
			getParams(WMS1022_R01Filter),
			WMS1022_R01List.length ?? 0
		));

		let newList = [...responseData.data.data ] as WMS1022_R01HeaderDto[];
		setWMS1022_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedWMS1022_R01,
				() => true,
			);
			setWMS1022_R01PastFilter(WMS1022_R01Filter); 
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedWMS1022_R01(defaultWMS1022_R01HeaderDto);
			setWMS1022_R01List([]);
			setWMS1022_R01DetailList([]); 
			setDeletedWMS1022_R01DetailList([]);
			setSelectedWMS1022_R01DetailList([]);
			setOriginalWMS1022_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [WMS1022_R01Filter, WMS1022_R01List, setWMS1022_R01List, setWMS1022_R01PastFilter, setSelectedWMS1022_R01, selectedWMS1022_R01, setScrollTop, setDetailScrollTop, setLotScrollTop])

	const fetchOne = useCallback(async () => {
		if (!selectedWMS1022_R01) return;

		const response = await getWMS1022_R01One(selectedWMS1022_R01.wmsOrderNo);

		return response.data.data as WMS1022_R01HeaderDto;
	}, [selectedWMS1022_R01]);
	

	const defaultWMS1022_R01HeaderRow = useCallback(() => {
		const logicCenter = wmsCdList[0]?.minorCd ?? '';
		const warehouseCdListToUse = warehouseCdList.filter(value =>
			value.logicCenter === logicCenter && value.materialYn === 'Y'
		);

		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(WMS1022_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				inoutClassList,
				inoutMethodList,
				inoutTypeList,
				wmsCdList,
				warehouseCdList: warehouseCdListToUse,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultWMS1022_R01HeaderDto };
		}

		return {
			...defaultWMS1022_R01HeaderDto,
			compCd: compCdList[0].compCd,
			inoutClass: inoutClassList.find(value => value.minorCd === '110')?.minorCd || '',
			inoutType: inoutTypeList.find(value => value.minorCd === 'IN')?.minorCd || '',
			logicCenter,
			warehouseCd: warehouseCdListToUse[0].warehouseCd,
			inoutMethod: inoutMethodList[0].minorCd,
			inserted: true,
		};
	}, [
		defaultWMS1022_R01HeaderDto, compCdList, wmsCdList, warehouseCdList,
		inoutMethodList, inoutClassList, inoutTypeList, validateCommonCodeLists,
	]);

	const defaultWMS1022_R01DetailRow = useCallback(() => {
		return {
			...defaultWMS1022_R01DetailDto,
			inserted: true,
		}
	}, [defaultWMS1022_R01DetailDto]);

	const defaultWMS1022_R01LotRow = useCallback(() => {
		return {
			...defaultWMS1022_R01LotDto,
			lotInputOption: 'N', // 로트입력여부 값 고정(N: 입력안함)
			inserted: true,
		}
	}, [defaultWMS1022_R01LotDto]);

	const fetchTransportHeader = useCallback(async () => {
		if (!selectedWMS1022_R01) return;

		const response = await getWMS1022_R01TransportHeader(selectedWMS1022_R01.wmsOrderNo);

		return response.data.data as WMS1022_R01HeaderDto;
	}, [selectedWMS1022_R01])
	
	const initContainerData = useCallback(() => {
		prevWmsOrderNoRef.current = undefined;
		initData();
		setWMS1022_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
		removeDeletedWMS1022_R01DetailList();
		removeSelectedWMS1022_R01DetailList();
		setEditWMS1022_R01({ ...defaultWMS1022_R01HeaderRow(), })
	}, [initData, defaultLabelPrintAuto, setWMS1022_R01Filter, removeDeletedWMS1022_R01DetailList, removeSelectedWMS1022_R01DetailList, setEditWMS1022_R01, defaultWMS1022_R01HeaderRow])

	const handleDeleteClick = useCallback(() => {

		if (deletedWMS1022_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedWMS1022_R01DetailList(deletedWMS1022_R01DetailList);
			removeSelectedWMS1022_R01DetailList();
			setWMS1022_R01DetailList([...WMS1022_R01DetailList]);
		} else if (selectedWMS1022_R01DetailList.length > 0) {
			addDeletedWMS1022_R01DetailList(selectedWMS1022_R01DetailList);
			removeSelectedWMS1022_R01DetailList(selectedWMS1022_R01DetailList);
		}
	}, [selectedWMS1022_R01DetailList, 
		deletedWMS1022_R01DetailList,
		addDeletedWMS1022_R01DetailList,
		removeDeletedWMS1022_R01DetailList,
		removeSelectedWMS1022_R01DetailList,
		setWMS1022_R01DetailList,
		WMS1022_R01DetailList]);
	
	const handleCreateClick = () => {
		setSelectedWMS1022_R01(undefined);
		setEditWMS1022_R01({ ...defaultWMS1022_R01HeaderRow(), })
		setWMS1022_R01DetailList([{...defaultWMS1022_R01DetailRow(), inserted: true}]);
		setDeletedWMS1022_R01DetailList([]);
		setSelectedWMS1022_R01DetailList([]);
		setOriginalWMS1022_R01DetailList([]);
	}

	const handleInsertClick = useCallback((e: React.MouseEvent, rowIndex?: number) => {
		const isGridInsert = rowIndex !== undefined;
		const lotGridData = WMS1022_R01LotMap?.get(selectedItemCdForLot || '') || [];

		InsertRowHandler({
			event: e,
			dataList: lotGridData,
			rowData: isGridInsert
				? lotGridData[rowIndex]
				: { ...defaultWMS1022_R01LotRow(), valueIndex: -1 },
			insertRow: insertWMS1022_R01LotList,
			defaultRowData: defaultWMS1022_R01LotRow(),
			...(isGridInsert && { setClickable }),
		});
	}, [WMS1022_R01LotMap, selectedItemCdForLot, insertWMS1022_R01LotList, defaultWMS1022_R01LotRow, setClickable]);

	const validateInsertData = (header: WMS1022_R01HeaderDto, detailList: WMS1022_R01DetailDto[]) => {
		
		//현재 예외입고 기능 없음
		if(!validateString(header.wmsOrderNo)) {
			showWarning('입고지시항목을 선택해서 저장해주세요.'); return false;
		}
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('물류센터를 선택해주세요.'); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('창고번호를 선택해주세요.'); return false;
		}
		// if (!validateString(header.empNo)) {
		// 	showWarning('입고담당자를 선택해주세요.'); return false;
		// }
		// if (!validateEmployeeCd(header.empNo, employeeCdList)) {
		// 	showWarning('입고담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		// }
		if(!validateString(header.inoutMethod)) {
			showWarning('입고구분을 선택해주세요.'); return false;
		}

		if(detailList.length === 0) {
			showWarning('상세내역을 입력해주세요.'); return false;
		}

		// 품목코드와 품목상태의 조합이 중복되는지 체크
		const itemStatusPairs = new Set<string>();
		for(const item of detailList) {
			if(!validateString(item.itemCd)) {
				showWarning('품목코드를 입력해주세요.'); return false;
			}
			if(!validateString(item.itemStatus)) {
				showWarning('품목의 상태를 선택해주세요.'); return false;
			}
			if(item.orderQty <= 0) {
				showWarning('수량을 입력해주세요.'); return false;
			}

			const pair = `${item.itemCd}-${item.itemStatus}`;
			if (itemStatusPairs.has(pair)) {
				showWarning(`품목코드 '${item.itemCd}'와(과) 품목상태 '${item.itemStatus}'의 조합이 중복되었습니다.`);
				return false;
			}
			//중복되지 않으면 검증용 set에 추가
			itemStatusPairs.add(pair);

			if(item.orderQty < item.transportQty + item.updateTransportQty) {
				showWarning(`입고량이 주문잔량보다 클 수 없습니다. - 품목코드: ${item.itemCd}, 품목상태: ${item.itemStatus}`); return false;
			}
		}
		

		return true;
	}

	const setInfoDetailList = useCallback((header: WMS1022_R01HeaderDto, detailList: WMS1022_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}))
	}, [setWMS1022_R01DetailList])

	
	const setInfoLotList = useCallback((lotMap: Map<string, WMS1022_R01LotDto[]>): Record<string, WMS1022_R01LotDto[]> => {
		const filteredLotMap: Record<string, WMS1022_R01LotDto[]> = {};

		lotMap.forEach((lots, itemCd) => {
			const filteredLots = lots.filter(lot => lot.lotQty && lot.lotQty > 0 && lot.inserted === true);
			if (filteredLots.length > 0) {
				filteredLotMap[itemCd] = filteredLots;
			}
		});

		return filteredLotMap;
	}, []);

	const refetchResponseDetailList = useCallback((responseData: WMS1022_R01Dto) => {
		
		let detailDtoList = responseData.wmsOrderDetailDtoList;

		detailDtoList = detailDtoList.map(value => ({
			...value,
			//주문잔량 다시 계산
			orderQtyView: value.orderQty - value.transportQty - value.updateTransportQty - value.cancelQty,
		}));

		//orderQtyView가 0이면 행을 삭제
		detailDtoList = detailDtoList.filter(value => value.orderQtyView > 0);
		responseData.wmsOrderDetailDtoList = detailDtoList;

		return responseData;
	}, [WMS1022_R01DetailList]);
	
	const assignLotNoToMaps = useCallback(async (currentLotMap: Map<string, WMS1022_R01LotDto[]>) => {
		const newLotMap = new Map<string, WMS1022_R01LotDto[]>();
		const promises: Promise<void>[] = [];

		for (const [itemCd, lots] of Array.from(currentLotMap.entries())) {
			const newLots = lots.map(lot => ({ ...lot }));
			
			newLots.forEach((lot) => {
				if (!validateString(lot.lotNo)) {
					const promise = createWMS1022_R01LotNo().then((res) => {
						if (res.data && res.data.successFlag) {
							lot.lotNo = res.data.data;
						}
					});
					promises.push(promise);
				}
			});
			newLotMap.set(itemCd, newLots);
		}

		if (promises.length > 0) {
			await Promise.all(promises);
			setWMS1022_R01LotMap(newLotMap);
		}

		return newLotMap;
	}, [setWMS1022_R01LotMap]);

	const handleSaveClick = useCallback(async () => {
		// console.log('[Save] labelPrintAuto:', WMS1022_R01Filter.labelPrintAuto);
		// console.log('[Save] lotMap:', WMS1022_R01LotMap);

		let valid = true;
		if(!validateInsertData(editWMS1022_R01!, WMS1022_R01DetailList)) valid = false;
		if(!valid) { return; }
		setLoadingSpinner(true);
		
		// STEP 0: 초기화 전에 LOT 번호 가져와서 WMS1022_R01LotMap의 각 row에 추가
		// ========================================
		const newLotMap = await assignLotNoToMaps(WMS1022_R01LotMap);

		// STEP 1: 저장 전에 미출력 라벨 데이터만 추출 (Lot라벨자동출력=Y일 때만). 저장 완료 후 STEP FINAL에서 일괄 출력
		let unprintedLabelData: LabelPrintData[] = [];
		if(WMS1022_R01Filter.labelPrintAuto === 'Y') {
			const store = useWMS1022_R01Store.getState();
			unprintedLabelData = WMS1022_R01_extractUnprintedLabelData(
				store,
				deletedWMS1022_R01LotList
			);
		}
		
		const lotMapObject = setInfoLotList(newLotMap);
		const deletedWMS1022_R01DetailList_Number = deletedWMS1022_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: WMS1022_R01DetailDto[] = [];
		let newHeaderList: WMS1022_R01HeaderDto[] = [];		
		let responseData: WMS1022_R01Dto = {
			wmsOrderHeaderDto: editWMS1022_R01!,
			wmsOrderDetailDtoList: WMS1022_R01DetailList,
			wmsStockLotDtoList: lotMapObject
		};

		if (selectedWMS1022_R01 && selectedWMS1022_R01.wmsOrderNo !== '') {

			newDetailList = WMS1022_R01DetailList
			.map(value => ({
				...value,
				transportQty: value.transportQty + value.updateTransportQty,
			}))
			.filter(value => 
				!deletedWMS1022_R01DetailList_Number.includes(value.valueIndex)
			);

			if (newDetailList.length === 0) {
				processName = 'delete';
				const deleteResponse = await deleteWMS1022_R01(selectedWMS1022_R01.wmsOrderNo);

				if(!deleteResponse || !deleteResponse.data.successFlag) { setLoadingSpinner(false); return; }

				newHeaderList = WMS1022_R01List.filter(value => value.wmsOrderNo !== selectedWMS1022_R01.wmsOrderNo);

				if (deleteResponse && deleteResponse.data) {
					if (deleteResponse.data.successFlag) {
						showSuccess('입고내역이 삭제 되었습니다.');
						setMessage('입고내역이 삭제 되었습니다.');
					}else return;
				}
			} else {
				processName = 'patch';
				const patchResponse = await patchWMS1022_R01({
					wmsOrderHeaderDto: editWMS1022_R01!,
					wmsOrderDetailDtoList: setInfoDetailList(editWMS1022_R01!, newDetailList),
					wmsStockLotDtoList: lotMapObject
				});

				if(!patchResponse || !patchResponse.data.successFlag) { setLoadingSpinner(false); return; }

				responseData = patchResponse.data.data[0];
				responseData = refetchResponseDetailList(responseData);

				if (editWMS1022_R01!.closeTag === 'Y') {
					newHeaderList = WMS1022_R01List.filter(value => value.wmsOrderNo !== editWMS1022_R01!.wmsOrderNo);
				} else {
					newHeaderList = WMS1022_R01List.map(value => {
						if (value.wmsOrderNo === responseData.wmsOrderHeaderDto.wmsOrderNo) {
							return responseData.wmsOrderHeaderDto;
						}
						return value;
					});
				}
				
				if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {

					showSuccess('입고내역이 등록 되었습니다.');
					setMessage('입고내역이 등록 되었습니다.');
				}
			}
		} else {
			//예외입고 과정은 나중에 듣기
			processName = 'post';
			const postResponse = await postWMS1022_R01({
				wmsOrderHeaderDto: editWMS1022_R01!,
				wmsOrderDetailDtoList: setInfoDetailList(editWMS1022_R01!, WMS1022_R01DetailList),
				wmsStockLotDtoList: lotMapObject
			});

			if(!postResponse || !postResponse.data.successFlag) { setLoadingSpinner(false); return; }

			responseData = postResponse.data.data[0];
			responseData = refetchResponseDetailList(responseData);

			newHeaderList = [
				...WMS1022_R01List,
				responseData.wmsOrderHeaderDto, // responseData에서 헤더를 가져옵니다.
			] as WMS1022_R01HeaderDto[];
			
			if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
				showSuccess('입고내역이 등록 되었습니다.');
				setMessage('입고내역이 등록 되었습니다.');
			}
		}


		if (processName === 'delete') {
			setWMS1022_R01List(newHeaderList);
			setSelectedWMS1022_R01(undefined);
			setWMS1022_R01DetailList([]);
			// handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setWMS1022_R01List(newHeaderList);
			setWMS1022_R01DetailList(responseData.wmsOrderDetailDtoList);

			const restoreLotMap = new Map<string, WMS1022_R01LotDto[]>();
			if(responseData.wmsOrderDetailDtoList) {
				responseData.wmsOrderDetailDtoList.forEach(detailItem => {
					restoreLotMap.set(detailItem.itemCd, [{...defaultWMS1022_R01LotRow(), inserted: true}]);
				})
			}
			

			//마감완료시에는 모든 상태를 초기화, 해당 입고정보 삭제
			if (responseData.wmsOrderHeaderDto!.closeTag === 'Y') {

				setWMS1022_R01List(newHeaderList.filter(value => value.wmsOrderNo !== editWMS1022_R01!.wmsOrderNo));
				setSelectedWMS1022_R01(undefined);
				setEditWMS1022_R01({ ...defaultWMS1022_R01HeaderRow(), })

				setWMS1022_R01DetailList([]);
				setOriginalWMS1022_R01DetailList([]);
				setWMS1022_R01LotList([]);
				setOriginalWMS1022_R01LotList([]);
				setWMS1022_R01LotMap(new Map<string, WMS1022_R01LotDto[]>());
				setSelectedWMS1022_R01DetailList([]);
				setSelectedItemCdForLot(null);
			} else{
			
				setWMS1022_R01LotMap(restoreLotMap);
				setSelectedWMS1022_R01(responseData.wmsOrderHeaderDto);
				setSelectedWMS1022_R01DetailList([1 as any]);
				setOriginalWMS1022_R01DetailList(responseData.wmsOrderDetailDtoList);
				if(responseData.wmsOrderDetailDtoList.length > 0){
					setSelectedItemCdForLot(responseData.wmsOrderDetailDtoList[0].itemCd);
				} else {
					setSelectedItemCdForLot(null);
				}

			}
		}

		// setSelectedWMS1022_R01(undefined);
		setDeletedWMS1022_R01DetailList([]);
		setTimeout(() => {
			setMessage('');
		}, 5000)
		
		setLoadingSpinner(false);

		// STEP FINAL: 저장 성공 후 미출력 라벨 일괄 출력 (Lot라벨자동출력=Y이고, 삭제가 아닐 때만)
		if (
			WMS1022_R01Filter.labelPrintAuto === 'Y'
			&& unprintedLabelData.length > 0 && processName !== 'delete'
		) {
			try {
				const ok = await printBulkLabel(unprintedLabelData, 'label1');
				if (ok) {
					showSuccess(`저장 완료! ${unprintedLabelData.length}개 라벨 출력`);
				} else {
					showWarning('저장은 완료되었으나 라벨 출력에 실패했습니다. 프린터 설정을 확인해주세요.');
				}
			} catch (error: any) {
				console.error('라벨 출력 실패:', error);
				showWarning(`저장은 완료되었으나 라벨 출력에 실패했습니다: ${error?.message || '알 수 없는 오류'}`);
			}
		}
	}, [
		WMS1022_R01Filter,
		editWMS1022_R01, 
		selectedWMS1022_R01, 
		WMS1022_R01DetailList, 
		WMS1022_R01LotMap,
		deletedWMS1022_R01DetailList,
		deletedWMS1022_R01LotList,
		WMS1022_R01List, setWMS1022_R01List,
		printBulkLabel,
	])

	//헤더의 정보를 받아서 기본값이 null이 아닌 빈 문자열 값을 찾아서 시스템코드의 기본값으로 표시되게 하기
	const handleDetailInfoCode = useCallback((headerData: WMS1022_R01HeaderDto): Partial<WMS1022_R01HeaderDto> => {
		const defaults: Partial<WMS1022_R01HeaderDto> = {};
		
		//일자를 당일로 초기화
		defaults.orderDt = formatDate(new Date());
	
		if (!validateString(headerData.compCd) && compCdList.length > 0) defaults.compCd = compCdList[0].compCd;
		if (!validateString(headerData.inoutMethod) && inoutMethodList.length > 0) defaults.inoutMethod = inoutMethodList[0].minorCd;

		if (!validateString(headerData.logicCenter) && wmsCdList.length > 0){
			defaults.logicCenter = wmsCdList[0].minorCd;
		}
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;

		let warehouseCdListToUse = warehouseCdListToUseList(defaults.logicCenter || '');
		if (!validateString(headerData.warehouseCd) && warehouseCdListToUse.length > 0) {
			defaults.warehouseCd = warehouseCdListToUse[0].warehouseCd;
		}
		defaults.warehouseCd = headerData.warehouseCd ? headerData.warehouseCd : defaults.warehouseCd;

		if (!validateString(headerData.inoutClass) && wmsInTypeCdList.length > 0) defaults.inoutClass = wmsInTypeCdList[0].minorCd;
		defaults.inoutClass = validateString(headerData.inoutClass) ? headerData.inoutClass : defaults.inoutClass;
	
		return defaults;
	}, [inoutMethodList, wmsCdList, compCdList, warehouseCdList]);
	
	const handleFetchDetailList = useCallback(async (wmsOrderNo: string, warehouseCd: string, isNewSelection: boolean, previousOrderNo: string | undefined) => {
		setLoadingSpinner(true);
		if (!warehouseCd) {
			showError('발주 정보의 물류정보의 조건에 맞는 창고 코드를 찾을 수 없어 입고 목록 내역을 조회할 수 없습니다.', 5000);
			setWMS1022_R01DetailList([]);
			await resetWMS1022_R01LotList([]);
			setSelectedWMS1022_R01DetailList([]);
			setSelectedItemCdForLot(null);
			setLoadingSpinner(false);
			return;
		}
		setLoadingSpinner(true);
		// 이전에 선택한 입고정보와 현재 선택한 입고정보가 같으면 상세내역 검색 중단
		if(!isNewSelection) { setLoadingSpinner(false); return; }

		try {
			const detailResponse = await getWMS1022_R01DetailList(wmsOrderNo, warehouseCd);
			const detailData = detailResponse.data.data;

			if (detailData && detailData.length > 0) {
				const currentDetailList = useWMS1022_R01Store.getState().WMS1022_R01DetailList;

				const existingItemsMap = new Map<string, WMS1022_R01DetailDto>();
				currentDetailList.forEach(item => {
					if (item.itemCd && item.itemStatus) {
						const key = `${item.itemCd}-${item.itemStatus}`;
						existingItemsMap.set(key, item);
					}
				});

				const updatedDetails = detailData.map((value) => {
					return {
						...value,
						valueIndex: value.valueIndex,
						orderIndex: value.orderIndex,
						orderIndexSeq: value.orderIndexSeq,
						orderPrice: value.orderPrice,
						orderQtyView: value.orderQty - value.transportQty - value.cancelQty,
						updateTransportQty: 0,
					}
				});
				setWMS1022_R01DetailList(updatedDetails);
				setOriginalWMS1022_R01DetailList(detailData);
				setMessage(`${selectedWMS1022_R01?.compNm}의 입고지시내역 ${detailData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);

				const firstDetail = useWMS1022_R01Store.getState().WMS1022_R01DetailList[0];
				await resetWMS1022_R01LotList(firstDetail ? [firstDetail] : []);
				if (firstDetail) {
					setSelectedWMS1022_R01DetailList([firstDetail.valueIndex] as any);
					setSelectedItemCdForLot(firstDetail.itemCd);
				}
				
			} else {
				showError('상세내역이 없습니다.');
				setWMS1022_R01DetailList([]);
				await resetWMS1022_R01LotList([]);
				setSelectedWMS1022_R01DetailList([]);
				setSelectedItemCdForLot(null);
				setLoadingSpinner(false);
			}
		} catch (error) {
			console.error("상세 내역 조회 실패:", error);
			showError('상세 내역을 조회하는 중 오류가 발생했습니다.');
			setWMS1022_R01DetailList([]);
			await resetWMS1022_R01LotList([]);
			setSelectedWMS1022_R01DetailList([]);
			setSelectedItemCdForLot(null);
			setLoadingSpinner(false);
		}
		setLoadingSpinner(false);
	}, [
		setMessage, 
		setWMS1022_R01DetailList,
		setOriginalWMS1022_R01DetailList,
		selectedWMS1022_R01?.compNm,
		setLotFetchTrigger
	]);

	const handleFetchLotList = useCallback(async (
		itemCd: string
	) => {
		if (!itemCd) {
			setWMS1022_R01LotMap(new Map<string, WMS1022_R01LotDto[]>());
			setWMS1022_R01LotList([]);
			setOriginalWMS1022_R01LotList([]);
			return;
		}

		// await resetWMS1022_R01LotList(WMS1022_R01DetailList);
		setSelectedItemCdForLot(itemCd);

	}, [
		WMS1022_R01DetailList, selectedWMS1022_R01DetailList,
		setWMS1022_R01LotList,
		setOriginalWMS1022_R01LotList,
	]);



	useEffect(() => {
		if (!detailFetchTrigger) return;
		const fetchAllDetailsForSelectedRow = async () => {
			if (!selectedWMS1022_R01 || !selectedWMS1022_R01.wmsOrderNo) {
				if (!selectedWMS1022_R01) {
					setWMS1022_R01DetailList([]);
					setOriginalWMS1022_R01DetailList([]);
					setWMS1022_R01LotList([]);
					setOriginalWMS1022_R01LotList([]);
				}
				prevWmsOrderNoRef.current = undefined; // 이전 선택 초기화
				return;
			}

			// 이전에 선택한 입고정보와 현재 선택한 입고정보가 다른지 확인
			// 다르면 상세 내역 조회 시 입고량 초기화
			const previousOrderNo = prevWmsOrderNoRef.current;
			const currentOrderNo = selectedWMS1022_R01.wmsOrderNo;

			const isNewSelection = previousOrderNo !== currentOrderNo;

			// 1. 입고 정보 먼저 가져오기
			const headerData = await fetchOne();

			// 2.출하 정보 먼저 가져와서 완전한 입고 정보인지 출하 전의 입고 정보인지 검증
			// 출하 정보 존재시 수정 불가
			const apiHeaderData = await fetchTransportHeader();
			if (apiHeaderData)	setTransportComplete(true);
			else				setTransportComplete(false);

			// 3. 현재 선택된 행과 API 데이터를 합쳐 기본값을 적용할 베이스 데이터를 만듭니다.
			const baseDataForDefaults = { ...defaultWMS1022_R01HeaderRow(), ...headerData, ...(apiHeaderData || {}) };
			const defaultValues = handleDetailInfoCode(baseDataForDefaults);

			//최종적으로 사용할 warehouseCd 결정
			const logicCenterToUse = baseDataForDefaults.logicCenter || defaultValues.logicCenter || '';
			const warehouseCdToUse = baseDataForDefaults.warehouseCd || defaultValues.warehouseCd || '';

			// 4. 입고 헤더 정보 업데이트
			setEditWMS1022_R01({
				...defaultWMS1022_R01HeaderRow(),
				...headerData,					// 선택된 행의 정보가 베이스
				...defaultValues,				// selectedWMS1022_R01의 기본값으로 비어있는 필드 채우기
				logicCenter: logicCenterToUse,
				warehouseCd: warehouseCdToUse,
			});

			// 5. 분리된 함수를 호출하여 상세 내역을 등록.
			handleFetchDetailList(selectedWMS1022_R01.wmsOrderNo, warehouseCdToUse, isNewSelection, previousOrderNo);
			// 이전
			prevWmsOrderNoRef.current = selectedWMS1022_R01.wmsOrderNo;
			setDetailFetchTrigger(false);
		};

		fetchAllDetailsForSelectedRow();
	}, [selectedWMS1022_R01, setEditWMS1022_R01, lotFetchTrigger, setLotFetchTrigger, setLoadingSpinner]);

	// 출하여부 판단 후 출하여부 존재시 발주정보 수정불가 처리
	useEffect(() => {
		const checkWmsTransport = async () => {
			setLoadingSpinner(true);
			if (!editWMS1022_R01?.wmsOrderNo) {
				setTransportComplete(false);
				setLoadingSpinner(false);
				return;
			}
			
			const response = await getWMS1022_R01WmsTransport(editWMS1022_R01?.wmsOrderNo || '');
			if (
				response.data.data &&
				response.data.data.transportNo !== null && response.data.data.transportNo !== '') {				
				setTransportComplete(true);
			} else {
				setTransportComplete(false);
			}
			setLoadingSpinner(false);
		};

		checkWmsTransport();
	}, [selectedWMS1022_R01, setLoadingSpinner]);


	useEffect(() => {
		setWMS1022_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
	}, [defaultLabelPrintAuto, setWMS1022_R01Filter]);
	
	return {
		clickable, setClickable,
		handleExcelClick,
		fetchData,
		defaultWMS1022_R01HeaderRow,
		defaultWMS1022_R01DetailRow,
		defaultWMS1022_R01LotRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleInsertClick,
		handleSaveClick,
		warehouseCdListToUseList,
		handleDetailInfoCode,
		handleFetchDetailList,
		handleFetchLotList,
	};
}
